const CATEGORY = "ads";

const GETTER_NAMES = {
  GET_ADS_MAP_BY_POSITION: "getAdsMapByPosition"
};

const ADS_POSITION_ENUM = {
  TOP: "top",
  MIDDLE: "middle",
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right"
};

const positions = Object.values(ADS_POSITION_ENUM);
const positionMap = () => positions.reduce((acc, key) => ({ [key]: [] }), {});

const GETTER_METHODS = {
  [GETTER_NAMES.GET_ADS_MAP_BY_POSITION]: state => {
    return state.ads.list.reduce((acc, ad) => {
      if (!positions.includes(ad.position)) return acc;
      if (!acc[ad.position]) acc[ad.position] = [];
      acc[ad.position].push(ad);
      return acc;
    }, positionMap());
  }
};

const getters = (state, getters) => (methodName, ...args) => {
  return GETTER_METHODS[methodName](state, getters, ...args);
};

export { CATEGORY, GETTER_NAMES, ADS_POSITION_ENUM, getters };
